import { formatDate } from '../../helpers/date'
import { DateFormat } from '../../types/dateFormatTypes'
import { Comment } from '../Comment/Comment'
import { Department } from '../Department/Department'
import {
    AddDistrictDivisionDistrictPlanningFormData,
    DistrictDivisionDistrictPlanning,
    EditDistrictDivisionDistrictPlanningFormData,
} from '../DistrictDivisionDistrictPlanning/DistrictDivisionDistrictPlanning'
import { transformToPeriod } from '../Period/PeriodTransformers'
import {
    AddDistrictDivisionDistrictTemporaryWorkerRequest,
    DistrictDivisionDistrictTemporaryWorkerResource,
    EditDistrictDivisionDistrictTemporaryWorkerOrderRequest,
} from './DistrictDivisionDistrictTemporaryWorker'

export const transformDistrictDivisionDistrictTemporaryWorkerToDistrictDivisionDistrictPlanning = (
    resource: DistrictDivisionDistrictTemporaryWorkerResource,
    department: Department,
    fullName: string,
    userId: string,
    districtDivisionDistrictId: string,
    comments: Comment[] = [],
): DistrictDivisionDistrictPlanning => {
    const start = new Date(resource.attributes.start)
    const end = new Date(resource.attributes.end)
    const period = transformToPeriod(start, end)

    return {
        id: resource.id,
        type: resource.type,
        planningOrder: resource.attributes.planningOrder,
        comments,
        department,
        districtDivisionDistrictId,
        period,
        fullName,
        userId,
    }
}

export const transformAddDistrictDivisionTemporaryWorkerFormDataToRequest = (
    formData: AddDistrictDivisionDistrictPlanningFormData,
): AddDistrictDivisionDistrictTemporaryWorkerRequest => ({
    type: 'districtDivisionDistrictTemporaryWorkers',
    attributes: {
        name: formData.name,
        planningOrder: formData.index,
        start: formatDate(formData.period.start, DateFormat.apiDateTime),
        end: formatDate(formData.period.end, DateFormat.apiDateTime),
    },
    relationships: {
        districtDivisionDistrict: {
            data: {
                type: 'districtDivisionDistricts',
                id: formData.districtDivisionDistrictId,
            },
        },
        department: {
            data: {
                type: 'departments',
                id: formData.departmentId,
            },
        },
    },
})

export const transformEditDistrictDivisionTemporaryWorkerOrderFormDataToRequest = (
    formData: EditDistrictDivisionDistrictPlanningFormData,
): EditDistrictDivisionDistrictTemporaryWorkerOrderRequest => ({
    id: formData.planningId,
    type: 'districtDivisionDistrictTemporaryWorkers',
    attributes: {
        planningOrder: formData.index,
    },
    relationships: {
        districtDivisionDistrict: {
            data: {
                type: 'districtDivisionDistricts',
                id: formData.districtDivisionDistrictId,
            },
        },
    },
})
